/* eslint-disable camelcase */
import { startCase, get } from 'lodash';
import numeral from 'numeral';
import React from 'react';
import PropTypes from 'prop-types';
import { Edit } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';

import TableRow from '../ReusableComponents/Table/TableRow';
import TableCell from '../ReusableComponents/Table/TableCell';

const useStyles = makeStyles()((theme) => ({
  edit: {
    fill: get(theme, 'palette.text.primary'),
    '&:hover': {
      fill: get(theme, 'palette.text.dark'),
      cursor: 'pointer',
    },
  },
}));

export default function LocationRow(props) {
  const { classes } = useStyles();
  const { editLocation, location, perms } = props;
  const {
    name,
    max_units_per_day,
    max_boxes_per_day,
    max_boxes_per_slot,
    max_units_per_vendor_per_day,
    min_booking_days,
    max_booking_days,
    max_vendors_per_slot,
  } = location;

  return (
    <TableRow>
      <TableCell>{startCase(name)}</TableCell>
      <TableCell>{numeral(max_units_per_day).format('0,0')}</TableCell>
      <TableCell>{numeral(max_boxes_per_day).format('0,0')}</TableCell>
      <TableCell>
        {numeral(max_units_per_vendor_per_day).format('0,0')}
      </TableCell>
      <TableCell>{numeral(max_boxes_per_slot).format('0,0')}</TableCell>
      <TableCell>{numeral(min_booking_days).format('0,0')}</TableCell>
      <TableCell>{numeral(max_booking_days).format('0,0')}</TableCell>
      <TableCell>{numeral(max_vendors_per_slot).format('0,0')}</TableCell>
      <TableCell>
        {perms.canUpdateLocation && (
          <Edit className={classes.edit} onClick={editLocation} />
        )}
      </TableCell>
    </TableRow>
  );
}

LocationRow.propTypes = {
  editLocation: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  perms: PropTypes.shape({
    canUpdateLocation: PropTypes.bool,
  }).isRequired,
};
